export const userTypes = {
    shopsAndBrands: "shopsAndBrands",
    shopper: "shopper",
    shopsAndBrandsAndShopper: "shopsAndBrandsAndShopper",
}